import { formatAgo } from './schedule';

/** ``"1 process"``, ``"3 processes"`` */
export const countProcesses = (count) => `${count} ${count === 1 ? 'process' : 'processes'}`;

/** What an update waits for, from ``GET busy``; empty while checking or when the check failed. */
export const blockingOf = (busy) => (busy?.processes || []).filter((process) => process.blocking);

/** Work that does not hold an update back, such as provider batches; it continues afterwards. */
export const continuingOf = (busy) => (busy?.processes || []).filter((process) => !process.blocking);

/** Whether the update would have to wait: something is running, or the check could not tell. */
export const mustWait = (busy) => Boolean(busy && !busy.loading && (busy.failed || blockingOf(busy).length));

/** ``"it finishes"``, ``"they finish"`` */
export const theyFinish = (count) => (count === 1 ? 'it finishes' : 'they finish');

/** The waiting card's sentence, from ``/status``'s ``waiting_for``. */
export function waitingSentence(count) {
    const until = count
        ? `The update starts once ${countProcesses(count)} ${count === 1 ? 'finishes' : 'finish'}.`
        : 'The update starts in a moment.';
    return `${until} Until then you can browse the platform, but not start new work.`;
}

/** ``"Training · editor@acme.com · 2 hours ago"``: what a process is, who started it and when. */
export function processDetails(process, now = new Date()) {
    return [
        process.name && process.kind !== 'Unknown' ? process.kind : null,
        process.started_by,
        process.started_at ? formatAgo(process.started_at, now) : null,
    ]
        .filter(Boolean)
        .join(' · ');
}
